import { TableColumn } from "./dataInterface";

export const contractTableColumn: TableColumn = {
  title: "エントリー一覧",
  detail: true,
  detailTitle: "エントリー詳細",
  detailColumn: "詳細",
  detailKey: ["id", "product_id", "service_id", "cancell_action"],
  addTitle: "エントリー",
  editAuth: [
    "マスターアカウント",
    "スタッフアカウント",
    "パートナー",
    "営業アカウント",
  ],
  tableFunction: [
    {
      name: "解約",
      width: "60px",
      auth: ["マスターアカウント", "スタッフアカウント"],
    },
    {
      name: "個人情報削除",
      width: "100px",
      auth: ["マスターアカウント", "スタッフアカウント"],
    },
    {
      name: "トスアップ複製",
      width: "100px",
      auth: ["パートナー", "営業アカウント"],
    },
    {
      name: "エントリー複製",
      width: "100px",
      auth: ["パートナー", "営業アカウント"],
    },
    {
      name: "エントリー取消",
      width: "120px",
      auth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
    },
  ],
  postCSVTitle: "契約状況 - CSV取込",
  dataColumn: [],
  subTable: [
    {
      subTableAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "コンテンツ一覧",
      subTableColumnLength: "service_content_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "100px",
      subTableDetail: false,
      subTableDetailTitle: "コンテンツ詳細",
      subTableAdd: false,
      subTableAddTitle: "コンテンツ追加",
      subTableAddTitleWidth: "160px",
      subTableEdit: false,
      subTableEditTitle: "コンテンツ編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [],
      subDataColumn: [
        {
          key: "service_content_name",
          name: "コンテンツ名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "顧客情報一覧",
      subTableColumnLength: "customer_info_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "100px",
      subTableDetail: false,
      subTableDetailTitle: "顧客情報詳細",
      subTableAdd: false,
      subTableAddTitle: "顧客情報追加",
      subTableAddTitleWidth: "160px",
      subTableEdit: false,
      subTableEditTitle: "顧客情報編集",
      subTableEditDirect: true,
      subTableEditDirectKey: "customer_info_value",
      subTableEditAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      tableFunction: [],
      subDataColumn: [
        {
          key: "customer_info_key",
          name: "質問名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "customer_info_value",
          name: "顧客情報",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "契約情報一覧",
      subTableColumnLength: "contract_info_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "100px",
      subTableDetail: false,
      subTableDetailTitle: "契約情報詳細",
      subTableAdd: false,
      subTableAddTitle: "契約情報追加",
      subTableAddTitleWidth: "160px",
      subTableEdit: false,
      subTableEditTitle: "契約情報編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [],
      subDataColumn: [
        {
          key: "contract_info_key",
          name: "項目名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "contract_info_value",
          name: "契約情報",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [],
    },
  ],
};
